import React, { useState, useEffect } from "react";
import GenericBoard from "../../../Generic/GenericBoard";
import { useSelector, useDispatch } from "react-redux";
import GenericTab from "../../../Generic/GenericTab";
import { getAllEnumFromServer } from "../../../../api/enum.api"
import { getProject } from "../../../../api/project.api";
import { getStatusProject } from "../../../../api/projectStatus.api";
import { Project } from "../../../../model/project.model";
import { Enum } from "../../../../model/enum.model";
import "./projectCostumer.css";
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import ChatTable from '../../../tasks/chat';
// import ProjectDetails from "../../detailProject/detailProject.component";
import ProjectDetails from "../ProjectDetails"

export const MainProject: React.FC = () => {
  // const [projectsData, setProjectsData] = useState<Project[]>();
  const [projects, setProjects] = useState<{ [key: string]: Project[] }>({});
  const [projectStatus, setProjectStatus] = useState<Enum[]>([]);
  const [view, setView] = useState("board");
  const [searchTerm, setSearchTerm] = useState('');
  const [showSearch, setShowSearch] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [statusOptions, setStatusOptions] = useState<Enum[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedProjectState, setSelectedProjectState] = useState<Project | null>(null);
  const projectReducer = useSelector((state: { Project: { allProject: { [key: string]: Project[] } } }) => state.Project);
  const dispatch = useDispatch();

  const config = {
    categoryField: "status.value",
    categories: [
      { label: "ממתינה לטיפול", color: "#2c6d8f" },
      { label: "בביצוע", color: "#2c6d8f" },
      { label: "בהמתנה", color: "#2c6d8f" },
      { label: "בוצע", color: "#2c6d8f" },
    ],
    displayFields: [
      { key: "businessName", label: "שם הפרויקט" },
      { key: "fullName", label: "לקוח" },
    ],
    actionLabel: "פרטים",
    idField: "projectId"

  };

  const configTab = {
    categoryField: "status.value",
    categories: config.categories,
    displayFields: [
      { key: "businessName", label: "שם הפרויקט" },
      { key: "fullName", label: "לקוח" },
      { key: "status.value", label: "סטטוס" },
    ],
    actionLabel: "פרטים",
  };

  useEffect(() => {
    fetchProjects();
    fetchStatuses();
  }, []);
  useEffect(() => {
    console.log(selectedProjectState)
  }, [selectedProjectState])
   const fetchProjects = async () => {
    try {
      const res = await getProject();

      const enriched = res.data.map((project: Project) => ({
        ...project,
        fullName: `${project.firstName ?? ''} ${project.lastName ?? ''}`.trim()
      }));

      const grouped = enriched.reduce((acc, project) => {
        const key = project.status?.value || "ללא סטטוס";
        if (!acc[key]) acc[key] = [];
        acc[key].push(project);
        return acc;
      }, {} as { [key: string]: Project[] });
      
      setProjects(grouped);
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  const fetchStatuses = async () => {
    try {
      const response = await getStatusProject();
      setProjectStatus(response.data);
    } catch (error) {
      console.error("Error fetching statuses:", error);
    }
  };
  const filteredProjects = Object.values(projects)
    .flat()
    .filter((project) => {
      const combined = [
        project.businessName,
        project.firstName,
        project.lastName,
        project.status?.value,
        project.email,
        project.phone,
      ]
        .join(" ")
        .toLowerCase();
      return combined.includes(searchTerm.toLowerCase());
      })
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
 const openProdPopup = (id: string) => {
  const selected = Object.values(projects).flat().find((p) => p.projectId === id);
console.log("gjufdjguf "+selectedProjectState)
  if (selected) {
    setSelectedProjectState(selected);
    setModalOpen(true);
  } else {
    console.warn("Project not found with id:", id);
  }
};


  return (
    <div>
      <div className="tabs-container">
        <div className={`tab ${view === "board" ? "active" : ""}`} onClick={() => setView("board")}>
          לוח
        </div>
        <div className={`tab ${view === "list" ? "active" : ""}`} onClick={() => setView("list")}>
          רשימה
        </div>
      </div>
      <div className="header">
        <div className="header-content">
          <div className="left-section">
            <button
              className="search-toggle"
              onClick={() => setShowSearch(!showSearch)}
              title="חיפוש"
            >
              <svg xmlns="http://www.w3.org/2000/svg" height="50" viewBox="0 0 24 24" width="50" fill="#2c3e50">
                <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C8.01 14 6 11.99 6 9.5S8.01 5 10.5 5 15 7.01 15 9.5 12.99 14 10.5 14z" />
              </svg>
            </button>

            {showSearch && (
              <input
                type="text"
                placeholder="חיפוש..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-line-inline"
                autoFocus
              />
            )}
          </div>

          <h1 className="project-title">פרויקטים</h1>
        </div>
      </div>

      <div>

        {view === "board" ? (
          <GenericBoard data={filteredProjects} openItemPopup={openProdPopup} config={config} />
        ) : (
          <GenericTab data={filteredProjects} config={configTab} />
        )}

      </div>
    {modalOpen && selectedProjectState && (
  <Modal  open={modalOpen} onClose={() => {
    setModalOpen(false);
    // fetchProjects(); // רענון הנתונים עם סגירת הפופאפ
  }}>
    <Box 
      sx={{

        backgroundColor: '#fff',
        display: "flex",
        flexDirection: 'row',
        padding: '20px',
        borderRadius: '10px',
        border: '1px solid #ccc',
        boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
        width: '80%',
        height: "90%",
        top: "50%",
        left: "50%",
        position: 'absolute',
        direction: 'rtl',
        transform: 'translate(-50%, -50%)'
      }}
    >
      <ProjectDetails  onClose={() => setModalOpen(false)} refreshProjects={fetchProjects} project={selectedProjectState} />
      <ChatTable itemId={selectedProjectState.projectId} />
    </Box>
  </Modal>
)}

    </div>
  );
};

